<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">
        @if (editMode) {
          {{ 'companyProfile.addService.editTitle' | translate }}
        } @else {
          {{ 'companyProfile.addService.title' | translate }}
        }
      </h2>
      <p class="text-muted mb-0">{{ 'companyProfile.addService.subtitle' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-12 mb-4">
          <label class="form-label required">{{ 'companyProfile.addService.name' | translate }}</label>
          <input
            type="text"
            class="form-control"
            formControlName="service_name"
            [placeholder]="'companyProfile.addService.namePlaceholder' | translate"
            [class.is-invalid]="form.get('service_name')?.invalid && form.get('service_name')?.touched"
          />
          @if (form.get('service_name')?.invalid && form.get('service_name')?.touched) {
            <div class="invalid-feedback">
              {{ 'companyProfile.addService.nameRequired' | translate }}
            </div>
          }
        </div>

        <div class="col-12 mb-4">
          <label class="form-label">{{ 'companyProfile.addService.description' | translate }}</label>
          <textarea
            class="form-control"
            formControlName="service_description"
            rows="3"
            [placeholder]="'companyProfile.addService.descriptionPlaceholder' | translate"
          ></textarea>
        </div>

        <div class="col-md-6 mb-4">
          <label class="form-label required">{{ 'companyProfile.addService.price' | translate }} <span class="text-muted fw-normal">({{ 'companyProfile.addService.exclVat' | translate }})</span></label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              formControlName="price"
              step="0.01"
              min="0"
              [class.is-invalid]="form.get('price')?.invalid && form.get('price')?.touched"
            />
            <span class="input-group-text">{{ form.get('currency')?.value }}</span>
          </div>
          @if (form.get('price')?.invalid && form.get('price')?.touched) {
            <div class="invalid-feedback d-block">
              {{ 'companyProfile.addService.priceRequired' | translate }}
            </div>
          }
        </div>

        <div class="col-md-6 mb-4">
          <label class="form-label">{{ 'companyProfile.addService.vatRate' | translate }}</label>
          <select class="form-select" formControlName="vat_rate">
            @for (option of vatOptions; track option.value) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="row w-100">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'neutral'"
          [label]="'common.cancel' | translate"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="editMode ? ('common.saveChanges' | translate) : ('companyProfile.addService.add' | translate)"
          [iconClass]="editMode ? 'fa fa-save' : 'fa fa-plus'"
          [loading]="saving"
          [disabled]="form.invalid"
          (clicked)="save()"
        />
      </div>
    </div>
  </div>
</div>
